import React, {useState, useEffect, useContext } from "react";
import {useNavigate} from "react-router-dom";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {PAContext} from "../../../Services/PAContext";
import Receipt from "../../../MasterEventObjects/Receipt";
import {
    Button, Paper, Typography
} from "@mui/material";
import {
    Plus,
    Sparkles,
} from "lucide-react";

import Box from "@mui/material/Box";
import './receipt.css';
import dayjs from "dayjs";
import ReceiptsAddNewCard from "./ReceiptsAddNewCard";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";


// Simulated AI function (Replace with actual API call)
const processReceiptsWithAI = async (receiptFiles, account) => {
    return receiptFiles.map((file, index) => ({
        id: dayjs().valueOf()+index,
        attendee_id: account?.id || "",
        amount: 0,
        currency: 'USD',
        file_type: file.type,
        file_name: file.name,
        file_size: file.size,
        full_data: file.full_data,
        full_data_loaded: false,
        thumbnail_data: "",
        thumbnail_loaded: false,
        location: {
            google_place_id:"",
            latitude: 0,
            longitude: 0,
            name:"",
            formatted_address:"",
            address:"",
            city:"",
            state:"",
            zip:"",
            country:"",
            phone_prefix:"",
            phone:"",
        },
        section: "General",
        section_item: 0,
        private: false,
        notes: "",
        last_modified: 0,
        status: 0,
        showDetails: false, // New: Controls the visibility of details
    }));
};



function ReceiptsAddNew() {

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, registerReceiptBinary, sendSocketMessage } = useContext(PAContext);
    const { Account } = dataArray;


    const [listOfReceipts, setListOfReceipts] = useState(() => {
        const receipt = new Receipt();
        receipt.attendee_id = Account.id;
        return [receipt];
    });

    useEffect(() => {
        console.log("listOfReceipts : ", listOfReceipts);
    }, [listOfReceipts]);

    const [manualReceipt, setManualReceipt] = useState(() => {
        const receipt = new Receipt();
        receipt.attendee_id = Account.id;
        return receipt;
    });

    function updateReceipt(updatedReceipt){
        setListOfReceipts((prevReceipts) =>
            prevReceipts.map((receipt) =>
                receipt.id === updatedReceipt.id ? updatedReceipt : receipt
            )
        );
    }

    function removeReceipt(receipt_id) {
        console.log("remove receipt : " + receipt_id);
        setListOfReceipts((prev) => prev.filter(receipt => receipt.id !== receipt_id));
    }

    function addManualReceipt() {
        console.log("addManualReceipt : ", manualReceipt);

        const newReceipt = new Receipt();
        newReceipt.attendee_id = Account.id;

        setListOfReceipts((prev) => [newReceipt, ...prev]);
    }

    function handleReceiptsAddOK() {
        console.log("listOfReceipts : ", listOfReceipts);

        // Ensure amount is always a valid number before calling .toFixed(2)
        const processedReceipts = listOfReceipts.map(receipt => ({
            ...receipt,
            amount: parseFloat(receipt.amount) || 0, // Ensure it's a valid number
        }));

        console.log("processedReceipts : ", processedReceipts);

        // Add the receipts to the global object
        set_PA_GlobalObject((prev) => ({
            Planning: {
                ...prev.Planning,
                receipts: [...(prev.Planning.receipts || []), ...processedReceipts],
            },
        }));

        //send each receipt to the server for processing
        if (PA_GlobalObject.Planning.status !== 10) {

            processedReceipts.forEach((_receipt) => {
                // Check if there is actually data to upload
                const hasData = _receipt.full_data && _receipt.full_data.length > 0;

                if (hasData) {
                    // Request GCS Path from server
                    // 2. Store the receipt in the Ref using its ID as the key
                    // This preserves the full_data (Base64) locally
                    registerReceiptBinary(_receipt.id, _receipt);

                    const _sendString = {
                        action: "E_requestEventReceiptUploadUrlForGCS", // Suggesting a clear action name
                        event_id: PA_GlobalObject.Planning.id,
                        receipt_id: _receipt.id,
                        file_name: _receipt.file_name,
                        file_type: _receipt.file_type
                    };
                    sendSocketMessage(_sendString);
                } else {
                    // No image? Just add the text data normally
                    const _sendString = {
                        action: "E_addEventReceipt_v2",
                        event_id: PA_GlobalObject.Planning.id,
                        receipt: _receipt
                    };
                    sendSocketMessage(_sendString);
                }
            });
        }

        navigate("/Planner/Receipts");
    }

    function handlePromptAddNewClose() {
        navigate("/Planner/Receipts");
    }



    return (


        <div className="receipts-list-container">

            {/* Clean, Unified Control Header Console */}
            <Paper
                elevation={0}
                sx={{
                    p: 1.2, // Shaved padding to maximize the 350px footprint
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)',
                    mb: 1.5 // Tight layout gap before cards
                }}
            >
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1}}>

                    {/* Title Area - Locked to prevent compression */}
                    <Box sx={{display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flexShrink: 0}}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
                            p: 0.8,
                            borderRadius: '8px',
                            display: 'flex',
                            boxShadow: '0 4px 10px rgba(99, 102, 241, 0.2)'
                        }}>
                            <i className="icon-receipt" style={{color: 'white', fontSize: '15px'}}/>
                        </Box>
                        <Box sx={{minWidth: 0}}>
                            <Typography variant="h6" sx={{
                                fontWeight: 800,
                                color: '#1e293b',
                                fontSize: '0.85rem',
                                letterSpacing: -0.3,
                                whiteSpace: 'nowrap'
                            }}>
                                New Receipts
                            </Typography>
                            <Typography variant="caption" sx={{
                                color: '#64748b',
                                fontWeight: 700,
                                fontSize: '0.6rem',
                                display: 'block',
                                lineHeight: 1
                            }}>
                                Staging ({listOfReceipts.length})
                            </Typography>
                        </Box>
                    </Box>

                    {/* Consolidated Actions Engine - Everything fits on one baseline */}
                    <Box sx={{display: 'flex', alignItems: 'center', gap: 0.8, flexShrink: 0}}>

                        {/* Secondary Action: Add blank slot to staging list */}
                        <Button
                            variant="text"
                            onClick={addManualReceipt}
                            startIcon={<i className="icon-plus" style={{fontSize: '10px', fontWeight: 900}}/>}
                            sx={{
                                color: '#10b981',
                                fontWeight: 800,
                                fontSize: '0.72rem',
                                textTransform: 'none',
                                borderRadius: '8px',
                                px: 1,
                                height: '32px',
                                whiteSpace: 'nowrap',
                                '&:hover': {
                                    bgcolor: 'rgba(16, 185, 129, 0.06)'
                                }
                            }}
                        >
                            More
                        </Button>

                        {/* Primary Action: Commit staged elements to global object */}
                        <Button
                            variant="contained"
                            onClick={handleReceiptsAddOK}
                            disabled={listOfReceipts.length === 0}
                            sx={{
                                bgcolor: '#10b981',
                                color: 'white',
                                fontWeight: 800,
                                fontSize: '0.75rem',
                                textTransform: 'none',
                                borderRadius: '8px',
                                px: 1.5,
                                height: '32px',
                                boxShadow: '0 4px 10px rgba(16, 185, 129, 0.2)',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    bgcolor: '#059669',
                                    boxShadow: '0 6px 14px rgba(16, 185, 129, 0.25)',
                                },
                                '&:disabled': {
                                    bgcolor: '#cbd5e1',
                                    color: '#94a3b8'
                                }
                            }}
                        >
                            Save
                        </Button>

                        <Divider orientation="vertical" variant="middle" flexItem
                                 sx={{my: 0.5, borderColor: '#e2e8f0'}}/>

                        {/* Dismissive Action: Abandon current staging space */}
                        <IconButton
                            size="small"
                            onClick={handlePromptAddNewClose}
                            sx={{
                                color: '#94a3b8',
                                borderRadius: '6px',
                                width: '28px',
                                height: '28px',
                                border: '1px solid #e2e8f0',
                                transition: 'all 0.15s ease',
                                '&:hover': {
                                    bgcolor: '#fef2f2',
                                    color: '#ef4444',
                                    borderColor: '#fca5a5'
                                }
                            }}
                        >
                            <i className="icon-cross" style={{fontSize: '10px', fontWeight: 'bold'}}/>
                        </IconButton>

                    </Box>
                </Box>
            </Paper>

            {/* Staged Content Track - Vertical headroom maximized */}
            <div className="receipts-add-new-item-container">
                {listOfReceipts.map((receipt) => (
                    <ReceiptsAddNewCard
                        key={receipt.id}
                        receipt={receipt}
                        updateReceipt={updateReceipt}
                        removeReceipt={removeReceipt}
                    />
                ))}
            </div>
        </div>
    );
}

export default ReceiptsAddNew;